import * as React from 'react'
import Image from 'next/image'
import { Container } from '../Container'
import { GraySection } from '../GraySection'

type Props = {
  title: string
  description: string
  reasons: { icon: any; title: string; description: any }[]
}
export const ConvenientAffordableSection: React.FC<Props> = ({ title, description, reasons }) => (
  <GraySection className="text-center">
    <Container>
      <h2 className="title">{title}</h2>
      <p className="description">{description}</p>
      <div className="grid md:grid-cols-3 gap-4">
        {reasons.map((item, index) => (
          <ConvenienceReason {...item} key={index} />
        ))}
      </div>
    </Container>
  </GraySection>
)

const ConvenienceReason: React.FC<{
  icon: any
  title: string
  description: any
}> = ({ icon, title, description }) => (
  <div>
    <div style={{ height: 65, width: '100%', position: 'relative' }}>
      <Image src={icon} layout="fill" objectFit="contain" className="mx-auto" />
    </div>
    <h3
      style={{
        paddingTop: '20px',
        fontSize: '18px',
        fontWeight: 600,
        lineHeight: '1.33',
        color: '#1a1919',
      }}
    >
      <strong>{title}</strong>
    </h3>
    <p className="description">{description}</p>
  </div>
)
